export default "__VITE_ASSET__D5qyqEW9__"